class IpdcProductsViewableItemCtrl {
    constructor() {
        'ngInject';

    }

    $onInit() {

        const languages = Object.keys(this.viewableItem);

        languages.forEach(function(item,i){
            if(item === "nl"){
                languages.splice(i, 1);
                languages.unshift(item);
            }
        });

        this.languages = languages;
        this.salectedLanguage = this.languages[0];
        this.viewableItemClass = this.viewableItemClass || '';
    }
}

class IpdcProductsViewableOrderedItemsCtrl {
    constructor() {
        'ngInject';
    }

    $onInit() {

        const languages = Object.keys(this.viewableItem);

        languages.forEach(function(item,i){
            if(item === "nl"){
                languages.splice(i, 1);
                languages.unshift(item);
            }
        });

        this.languages = Object.keys(this.viewableItem);
        this.salectedLanguage = this.languages[0];
        this.viewableItemClass = this.viewableItemClass || '';
    }
}

(function () {
    'use strict';

    angular.module('doclr.ipdc')
        .component('ipdcViewableItem', {
            templateUrl: '/partials/ipdcproducts/producten.viewable-item.html',
            controller: IpdcProductsViewableItemCtrl,
            controllerAs: 'IpdcProductsViewableItemCtrl',
            bindings: {
                viewableItem: '<',
                viewableItemClass: '<',
                name: '<',
            }
        }).component('ipdcViewableOrderedItems', {
            templateUrl: '/partials/ipdcproducts/producten.viewable-ordered-items.html',
            controller: IpdcProductsViewableOrderedItemsCtrl,
            controllerAs: 'IpdcProductsViewableOrderedItemsCtrl',
            bindings: {
                viewableOrderedItem: '<',
                viewableItemClass: '<',
            }
        });
})();